import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MemorizzatoreEntitaService } from 'src/app/common/sharedServices/memorizzatoreEntita/memorizzatore-entita.service';
import { StatoInterventoAperto,  } from 'src/app/common/models/Intervento';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class TestateInterventiApertiService extends MemorizzatoreEntitaService<StatoInterventoAperto> {
  private readonly STORAGE_KEY_INTERVENTI_DA_SINCRONIZZARE = '__interventiAperti';

  private listaIdInterventiApertiSubject: Subject<number[]>;

  constructor(storage: Storage) {
    super(storage);
  }

  protected getChiaveDB(): string {
    return this.STORAGE_KEY_INTERVENTI_DA_SINCRONIZZARE;
  }

  /**
   * I sottoscriventi possono essere aggiornati sulla variazione dell'elenco
   * di tutti gli id che hanno modifiche locali non comunicate al server
   */
  async getElencoIdInterventiAperti(): Promise<Observable<number[]>> {
    if (!this.listaIdInterventiApertiSubject) {
      await this.aggiornaObservableIdInterventiAperti();
      return this.listaIdInterventiApertiSubject.asObservable();
    } else {
      return this.listaIdInterventiApertiSubject.asObservable();
    }
  }

  protected verificaUguaglianzaEntita(a: StatoInterventoAperto, b: StatoInterventoAperto): boolean {
    return a.datiTestata.idIntervento === b.datiTestata.idIntervento;
  }

  /**
   * Salva su Db un intervento le cui modifiche sono ancora da sincronizzare.
   * Se era gia' presente su DB il suo stato precedente viene SOVRASCRITTO
   * 
   * @param intervento 
   */
  async salvaInterventoAperto(statoIntervento: StatoInterventoAperto): Promise<void> {
    await this.aggiornaEntita(statoIntervento); // Sovrascrive o inserisce
    this.aggiornaObservableIdInterventiAperti();
  }

  /**
   * Ritorna lo stato dell'intervento aperto, se presente, 
   * identificato dall'id 
   * @param idIntervento id dell'intervento da cercare nell'elenco offline
   * @returns statoIntervento oppure null
   */
  async getInterventoAperto(idInterventoDaCercare: number): Promise<StatoInterventoAperto> {
    const interventiAperti = (await this.getElencoEntita());
    const idInterventiOffline = interventiAperti.map(statoIntervento => {
      return statoIntervento.datiTestata.idIntervento;
    });

    const indiceOccorrenza = idInterventiOffline.indexOf(idInterventoDaCercare);
    if (indiceOccorrenza !== -1) {
      return interventiAperti[indiceOccorrenza];
    } else {
      return null;
    }
  }

  async rimuoviIntervento(intervento: StatoInterventoAperto): Promise<void> {
    await this.rimuoviEntita(intervento);
    this.aggiornaObservableIdInterventiAperti();
  }

  /**
   * Dopo un'operazione di aggiornamento ritrasmetto l'elenco
   * degli id di tutti gli interventi aperti ai sottoscriventi
   * @returns elenco degli id degli interventi aperti attualmente presenti
   * su db
   */
  private async aggiornaObservableIdInterventiAperti(): Promise<number[]> {
    const interventiAperti = await this.getElencoEntita();
    const elencoId = interventiAperti.map(statoIntervento => statoIntervento.datiTestata.idIntervento);
    if (!this.listaIdInterventiApertiSubject) { 
      this.listaIdInterventiApertiSubject = new BehaviorSubject<number[]>(elencoId);
    } else {
      this.listaIdInterventiApertiSubject.next(elencoId);
    }
    return elencoId;
  }


  /*   private async rimuoviInterventoById(idInterventoDaRimuovere: number): Promise<boolean> {
      // RIMUOVERE SE SUPERFLUO
      const interventiOffline = (await this.getElencoEntita());
      const idInterventiOffline = interventiOffline.map(item => {
        return item.datiTestata.idIntervento;
      });
  
      const indiceOccorrenza = idInterventiOffline.indexOf(idInterventoDaRimuovere);
      if (indiceOccorrenza === -1) {
        console.warn(`Non e' stato trovato l'intervento ${idInterventoDaRimuovere} che si voleva rimuovere da elenco da sincronizzare`);
        return false;
      } else {
        const interventiFiltrati = interventiOffline.filter(intervento => (intervento.datiTestata.idIntervento !== idInterventoDaRimuovere));
        await this.salvaEntita(interventiFiltrati);
        return true;
      }
    }
   */
}
